import Vue from 'vue'
import Router from 'vue-router'

import zhgdRouter from './zhgd'
import jianguanRouter from './jianguan'
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('@/components/sign/login')
        },
        {
            path: '/',
            name: 'index',
            meta: {
                requireAuth: true
            },
            component: () => import('@/components/zhgd/frame'),
            children: zhgdRouter.routes
        },
        {
            path: '/jianguan',
            name: 'jianguan',
            meta: {
                requireAuth: true
            },
            component: () => import('@/components/zhgd/frame2'),
            children: jianguanRouter.routes
        },
        {
            path: '*',
            component: () => import('@/components/miss')
        },
        // {
        //     path: '/dust',
        //     meta: {
        //         requireAuth: true
        //     },
        //     component: () => import('@/components/dust/frame'),
        //     children: mainRouter.routes
        // },
        // {
        //     path: '/tower',
        //     meta: {
        //         requireAuth: true
        //     },
        //     component: () => import('@/components/tower/frame'),
        //     children: towerRouter.routes
        // },
        // {
        //     path: '/video',
        //     meta: {
        //         requireAuth: true
        //     },
        //     component: () => import('@/components/video/frame'),
        //     children: videoRouter.routes
        // },
        // {
        //     path: '/lifter',
        //     meta: {
        //         requireAuth: true
        //     },
        //     component: () => import('@/components/lifter/frame'),
        //     children: lifterRouter.routes
        // },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js